import { PriceAlert } from '../../types/entities';

export interface PriceAlertState {
  loading: boolean;
  loaded: boolean;
  pending: boolean;
  clearing: boolean;
  error?: string;
  priceAlerts: PriceAlert[];
}

export const initialPriceAlertState: PriceAlertState = {
  loading: false,
  loaded: false,
  pending: false,
  clearing: false,
  error: undefined,
  priceAlerts: []
};
